__turbopack_context__.v({
  "icon": "AddProductCard-module-scss-module__GVvxSa__icon",
  "root": "AddProductCard-module-scss-module__GVvxSa__root",
});
